<span class="label">{{ label() }}</span>
<span class="value">
  @if (loading()) {
    <xemex-skeleton-block width="80%" height="16px" />
  } @else {
    <span
      #valueContent
      class="value__content"
      [class.value__content--hidden]="showFallback()"
      [class.value__content--truncate]="truncate()"
      [matTooltip]="tooltipText()"
      [matTooltipDisabled]="!truncate() || !isTruncated()"
    >
      <ng-content />
    </span>
    @if (showFallback()) {
      <span class="value__fallback">—</span>
    }
  }
</span>
